import { render, staticRenderFns } from "./ArticlePreview.vue?vue&type=template&id=38ad3a9f&scoped=true"
import script from "./ArticlePreview.vue?vue&type=script&lang=js"
export * from "./ArticlePreview.vue?vue&type=script&lang=js"
import style0 from "./ArticlePreview.vue?vue&type=style&index=0&id=38ad3a9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ad3a9f",
  null
  
)

export default component.exports